import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Box, Badge, IconButton, useMediaQuery } from "@mui/material";
import request from "../utilities/requests";
import { EventContext } from "../contexts/EventContext";
import { toast } from "../utilities/SnackBarUtils";

const NotificationIcon = ({ color }) => {
  const navigate = useNavigate();
  const { socket, notificationCount, setNotificationCount } = useContext(EventContext);
  const isDesktop = useMediaQuery("(min-width:600px)");
  const [pulse, setPulse] = useState(false);

  // Placeholder: call server to get unread count
  const fetchUnreadCount = async () => {
    try {
      const result = await request("notification/count");
      if (result.success) {
        setNotificationCount(result.count);
      }
    } catch (error) {
      console.log("Error fetching unread count", error);
    }
  };

  const handleConnectError = (err) => {
    // Silent self-heal: refresh token from localStorage and reconnect
    console.warn("[socket connect_error] attempting silent token refresh");
    try {
      const newToken = localStorage.getItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
      );
      if (newToken) {
        socket.auth = { ...(socket.auth || {}), token: newToken };
        if (socket.connected) {
          socket.disconnect().connect();
        } else {
          socket.connect();
        }
      } else {
        // No token available; optional: keep a single console for debugging
        console.error(
          "[socket] no access token in localStorage; cannot refresh auth"
        );
      }
    } catch (e) {
      console.error("[socket] token refresh failed", e);
    }
  };

  const handleNewNotifications = async () => {
    await fetchUnreadCount();
    setPulse(true);
    setTimeout(() => setPulse(false), 500);
    toast.success("New notification received!");
  };

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  useEffect(() => {
    if (!socket) return;

    // Avoid duplicate listeners in StrictMode
    if (!socket._notificationInit) {
      socket._notificationInit = true;

      socket.on("connect_error", handleConnectError);
      socket.on("new_notification", handleNewNotifications);

      if (!socket.connected) {
        socket.connect();
      }
    }

    return () => {
      // cleanup only the attached listeners
      socket.off("connect_error", handleConnectError);
      socket.off("new_notification", handleNewNotifications);
      socket._notificationInit = false;
    };
  }, [socket]);

  const handleClick = () => {
    navigate("/notifications");
  };

  const style = isDesktop
    ? {
        position: "fixed",
        top: 16,
        right: 16,
        // zIndex: 999999,
      }
    : {
        position: "static",
      };

  return (
    <Box id="notification-bell-icon" sx={style}>
      <IconButton onClick={handleClick}>
        <Badge
          badgeContent={notificationCount}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              animation: pulse ? "pulse 1s ease-in-out" : "none",
              backgroundColor: isDesktop ? undefined : "#fff",
              color: isDesktop ? undefined : "#000",
            },
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(2.3)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          <NotificationsNoneIcon style={{ color }} />
        </Badge>
      </IconButton>
    </Box>
  );
};

export default NotificationIcon;
